module.exports = __webpack_public_path__ + "img/google-chrome.29d3736b.png";